import React from "react";

export const Experience = ({duration,jobTitle,company,location,description})=> {
    return (
        <div class="card shadow border-0 rounded-4 mb-5">
        <div class="card-body p-5">
            <div class="row  gx-5">
                <div class="col text-center text-lg-start mb-4 mb-lg-0">
                    <div class="bg-light p-4 rounded-4">
                        <div class="text-primary fw-bolder mb-2">{duration}</div>
                        <div class="small fw-bolder">{jobTitle}</div>
                        <div class="small text-muted">{company}</div>
                        <div class="small text-muted">{location}</div>
                    </div>
                </div>
                <div class="col-lg-8"><div>
                    <ul>
                        {description.map((text,i)=>(
                            <li key={i}>{text}</li>
                        ))}
                    </ul>
                </div></div>
            </div>
        </div>
    </div>
    )
}